import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useIsPandaDocDown(): boolean {
  return useCbhFlag(CbhFeatureFlag.IS_PANDA_DOC_DOWN, {
    defaultValue: false,
  });
}
